import axios from "axios";
import { API, Amplify } from "aws-amplify";
import config from "../config";

const DEFAULT_VERSION = "1.0";
const API_URL = config.apiGateway.URL;
const YOUTUBE_URL = config.web.YOUTUBE_URL;
const API_KEY = config.web.API_KEY;
Amplify.configure({
  API: {
    endpoints: [
      {
        name: "video",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    ],
  },
});
//console.log('API_URL=',API_URL);
//console.log('YOUTUBE_URL=',YOUTUBE_URL);
//console.log('API_KEY=',API_KEY);

const read = async (params, signal) => {
  console.log("read params=", params);
  const id = params.videoId;
  return API.get("video", `/api/video/${id}`);
};

const listByChannel = (params) => {
  console.log("API_URL=", API_URL);
  console.log("listByChannel params=", params);
  const id = params.channelId;
  return API.get("video", `/api/video/by/${id}`);
};

const getChannelInfo = async (params) => {
  console.log("getChannelInfo params=", params);
  const channelId = params.channelId;
  const channelSummary = params.channelSummary;
  const gender = params.gender;
  //https://www.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2Cstatistics&id=UCgsffS7MfKL6YU3r_U3E-aA&key=[YOUR_API_KEY]
  const url = `${YOUTUBE_URL}&id=${channelId}&key=${API_KEY}`;
  console.log("url=", url);
  const options = {
    method: "GET",
    url,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  try {
    let response = await axios(options);
    console.log("api-video getChannelInfo -- response=", response);
    // find all HIT for video and add HIT property to video
    const channelInfoData = response.data;
    const snippet = channelInfoData.items[0].snippet;
    const statistics = channelInfoData.items[0].statistics;
    if (channelInfoData) {
      const channelInfo = {
        channelId,
        channelSummary,
        gender,
        channelTitle: snippet.title,
        publishedAt: snippet.publishedAt.split("T")[0],
        viewCount: parseInt(statistics.viewCount).toLocaleString(),
        videoCount: statistics.videoCount,
        thumbnailUrl: snippet.thumbnails.default.url,
      };
      console.log("channelInfo=", channelInfo);
      return channelInfo;
    }
    return {};
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      let response = Object.assign({}, error.response);
      const errorData = error.response.data;
      response.data = { error: errorData };
      console.log("error response=", JSON.stringify(response));
      return response;
    } else if (("no response with request:", error.request)) {
      // The request was made but no response was received
      console.log(error.request);
      return { data: { error: "No response with request" }, status: 401 };
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error in request:", error.message);
      return { data: { error: "Error in request" }, status: 401 };
    }
  }
};

const readCap = async (params, signal) => {
  try {
    console.log("readCap params=", params);
    const version = params.version ? params.version : DEFAULT_VERSION;
    const id = `${params.videoId}:${version}`;
    const resCap = await API.get("video", `/api/cap/video/${id}`);
    console.log("readCap resCap=", resCap);
    return resCap;
  } catch (err) {
    //console.log("err=", err);
    return ({ text_en: null });
  }
};

export { read, listByChannel, getChannelInfo, readCap };
